<template>
  <div
    class="ios-membership"
    :class="{ content: userData }"
  >
    <h1>Existing members</h1>
    <p>
      This app is for people who already have a To Be Legacy account.
    </p>
    <p>
      Log in with the email and password you used when you enrolled.
      New programs are added to that same account.
    </p>
    <div class="ios-membership-actions">
      <b-button
        v-if="!userData"
        variant="primary"
        :to="{ name: 'login' }"
      >
        Log In
      </b-button>
      <b-button
        v-else
        variant="primary"
        :to="{ name: 'main' }"
      >
        Go to Library
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IosMembership',
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
  metaInfo: {
    title: 'Existing Members',
  },
};
</script>

<style lang="scss" scoped>
.ios-membership {
  max-width: 32rem;
  margin: 1.5rem auto 3rem;
  padding: 0 1rem;
}

h1 {
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

p {
  margin-bottom: 1rem;
}

.ios-membership-actions {
  display: flex;
  justify-content: center;
}
</style>
